import React from "react";
import "../Style/Mint.css";

function Note() {
  return (
    <div className="col-lg-6">
      <div id="Actions">
        <div className="note text-center">
          <header>
            <p>
              <strong>2 free + gas mint per wallet.</strong> Don't be greedy.
              That's how Gandalf created the legend.
            </p>
          </header>
          <img className="divide" src="/images/GT-phone-header-border.png" />
          <main>
            <div className="row flex-column align-items-center">
              <div className="col-lg-6 col-md-5 col-sm-4 d-flex justify-content-center">
                <img id="Cage" src="/images/GT-cage.png" className="nft__img" />
              </div>
              <div className="col-12 d-flex align-items-center justify-content-center">
                <p className="mt-4">
                  <strong>We are reserving 1,000 Gandalf.</strong> Because
                  that's what the Wise Man want.
                </p>
              </div>
            </div>
          </main>
          <img className="divide" src="/images/GT-phone-header-border.png" />
          <footer>
            <p>
              No roadmap. No Discord. No utility. CC0.{" "}
              <a
                href="https://etherscan.io/address/0xbce3781ae7ca1a5e050bd9c4c77369867ebc307e#code"
                target="_blank"
              >
                Contract
              </a>{" "}
              was actually written by Gandalf The White.
            </p>
          </footer>
          <div id="Follow">
            <span>#GANDALFOLLOWGANDALF</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Note;
